import { useContext, useState } from "react";
import NetworkError from "../../components/NetworkError";
import { config } from "../../constants/config";
import { useEffect } from "react";
import Preloader from "../../components/Preloader";
import { Link, useNavigate } from "react-router-dom";
import User from "../../components/users/user";
import UserContext from "../../contexts/UserContext";
import Search from "../../components/Search";
import PaginationSelect from "../../components/sPaginationSelect";



export default function Users() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [elementsList, setElementsList] = useState([]);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');
    const [nbpage, setNbpage] = useState(1);
    const [page, setPage] = useState(0);
    const [currentpage, setCurrentpage] = useState('');

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?limit=${config.secure.limit}&page=${p + 1}`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setNbpage(data?.body?.pages);

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            if (element.email !== "jamesdouanla@gmail.com" && element.email !== "marcelngom26@gmail.com") {
                                clientarraydata.push({ ...element });
                            }
                        });

                        // console.log("liste in data", clientarray)
                        if (user?.isFullAction) {
                            setElementsList(clientarray);
                        } else {
                            setElementsList(clientarraydata);
                        }

                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const autoSearchElement = async (c) => {

        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.secure.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            // var urlencoded = new URLSearchParams();
            // urlencoded.append("cpte", user.code);
            // urlencoded.append("prof", user.profil);
            // urlencoded.append("conn", user.token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?crit=${c}`, requestOptions).then((response) => {

                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // console.log("resonse jsondecode", data);
                            let clientarray = [];
                            clientarray = data?.body?.data;

                            let clientarraydata = [];
                            await clientarray.forEach(element => {
                                if (element.email !== "jamesdouanla@gmail.com" && element.email !== "marcelngom26@gmail.com") {
                                    clientarraydata.push({ ...element });
                                }
                            });

                            // console.log("liste in data", clientarray)
                            if (user?.isFullAction) {
                                setElementsList(clientarray);
                            } else {
                                setElementsList(clientarraydata);
                            }
                            setNbpage(data?.body?.pages);

                            // setLoading(false);
                        } else {
                            if (data?.body?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }


    // comportements
    useEffect(() => {
        getElementsList(page);
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchElement(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-4 font-weight-bold text_primary">Users</h1>
                <div className="row">
                    <div className="col-md-2 mb-3">
                        <PaginationSelect nbpage={nbpage} getList={getElementsList} page={page} setPage={setPage} current={currentpage} setCurrent={setCurrentpage} />
                    </div>
                    <div className="col-md-10 mb-3">
                        <Search
                            chaine={chaine}
                            setChaine={setChaine}
                            // search={searchEmployee}
                            placeholder="Search a user..."
                        />
                    </div>
                    <div className="col-md-12">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <Link to="/new-user" data-toggle="tooltip" title="New user" data-placement="left" className="btn-shadow ml-3 btn btn-primary btn-sm float-right">
                                    <i className="fa fa-plus mr-1"></i> <span>New user</span>
                                </Link>
                                <h6 className="m-0 ">List of users</h6>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive mb-3">
                                    <table className="mb-0 table table-bordered">
                                        <thead className="bg-primary">
                                            <tr className="bg-primary text-white">
                                                <th className="text-center">#</th>
                                                <th>User</th>
                                                <th>Phone</th>
                                                <th>Email</th>
                                                <th>Account type</th>
                                                <th>Added date</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(elementsList.length === 0) && <tr style={{ borderStyle: "none" }}>
                                                <th colSpan={7} className="text-center">No user found</th>
                                            </tr>}
                                            {
                                                (elementsList.length > 0) && elementsList?.map((item, index) => (
                                                    <User user={item} position={(config.secure.limit * page) + index} key={index} />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )

}